import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WSPhone from "../../Components/Phone/WSPhone";
import WSTextField from "../../Components/TextBox/WSTextBox";
import {
    callAPI,
    customValidation,
    EPhone,
    formatPhoneNumber,
    getLocalValue,
    LoacalVariables,
    Method,
    validations,
} from "../../commonFunctions/CommonFunctions";
import backImg from "../../images/Rectangle.svg";
import logo from '../../images/melplogo1.svg';

import { useNavigate } from "react-router-dom";
import ThankYouDialog from "../../Backend/pop/ThankYouDialog";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import backgroundImage1 from '../../images/bg2.svg';

export const VendorProfile: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const {
        control,
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();
    useEffect(() => {
        setValue('phoneNumber', getLocalValue(LoacalVariables.Phone))
        setValue('email', getLocalValue(LoacalVariables.Email) || "")
        setValue('name', getLocalValue(LoacalVariables.Name))
    }, [])
    const navigate = useNavigate();
    const handleData = async (data: any) => {
        try {
            setLoading(true);
            const request = await setRequest(data);

            console.log("=== FORM DATA ===");
            for (let [key, value] of request.entries()) {
                console.log(`${key}:`, value);
            }

            // Use your existing callAPI
            const response: any = await callAPI("VendorProfile", Method.POSTFORMDATA, null, null, request);
            console.log("✅ RESPONSE:", response);

            if (response?.success === true) {
                showMessage(response.message, "success");
                setOpen(true);
                setTimeout(() => navigate(`/vendor-product/list`), 1500);
            } else {
                showMessage(response?.message || "Failed to save profile", "error");
            }
        } catch (error: any) {
            console.error("ERROR:", error);
            showMessage(error.response?.data?.title || "Validation failed", "error");
        } finally {
            setLoading(false);
        }
    };


    const vendorTypeSouse = {
        url: "VendorTypeMaster/search",
        page: 1,
        pageSize: 100000,
        filter: [],
        sort: [],
    };
    const transFormDataVendorType = (data: any) => {
        console.log('data vendor are0', data)
        const qualifications: Array<any> = []
        if (data) {
            data.map((item: any) => {
                qualifications.push({ label: item.typeName, value: item.id })
            })
        }
        return qualifications;
    }
    // In VendorProfile setRequest function:
    const setRequest = async (data: any) => {
        try {
            const formData = new FormData();
            const userId = getLocalValue(LoacalVariables.UserId);

            console.log("🔑 UserId:", userId);

            if (!userId) {
                throw new Error("Please login first");
            }

            formData.append("userId", userId);
            formData.append("name", data.name || "");
            formData.append("vendorTypeId", data.vendorTypeId || "");
            formData.append("phoneNumber", formatPhoneNumber(data.phoneNumber, EPhone.RemoveHyphen));
            formData.append("companyName", data.companyName || "");
            formData.append("email", data.email || "");
            formData.append("licenceNumber", data.licenceNumber || "");
            formData.append("gstNumber", data.gstNumber || data.GSTNumber || "");
            formData.append("panNumber", data.panNumber || "");
            formData.append("addressLine1", data.addressLine1);
            formData.append("addressLine2", data.addressLine2 || "");
            formData.append("state", data.state);
            formData.append("city", data.city);
            formData.append("pincode", data.pincode);
            formData.append("websiteUrl", "-");

            return formData;
        } catch (e: any) {
            console.error("FormData error:", e);
            throw e;
        }
    };



    const handleOnClose = () => {
        setOpen(false)
        navigate('/')
    }
    return (
        <>
            <Grid item container>
                <Grid
                    container
                    sx={{
                        position: 'relative',
                        minHeight: '100vh',
                        backgroundImage: `url(${backImg})`,

                        backgroundSize: 'cover',
                        backgroundColor: '#022219',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',

                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 2,
                    }}
                >
                    <Box
                        component="img"
                        src={logo}
                        alt="MELP Logo"
                        sx={{
                            position: 'absolute',
                            top: 24,
                            left: 54,
                            width: 100,
                            zIndex: 10,
                        }}
                    />
                    <Grid container sx={{
                        position: 'relative',
                        minHeight: '80vh',
                        backgroundImage: `url(${backgroundImage1})`,
                        border: '1px solid #022219',
                        borderRadius: 5,
                        backgroundSize: 'cover',
                        backgroundColor: '#022219',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '80%',
                        padding: 7,
                    }}>
                        <form onSubmit={handleSubmit(handleData)}>
                            <Box
                                sx={{
                                    backgroundColor: "white",
                                    padding: "30px",
                                    borderRadius: "12px",
                                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                    maxWidth: "800px",
                                    width: "100%",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    style={{ color: "#098963" }}
                                >
                                    Complete Vendor Profile{" "}
                                    <span style={{ color: "#FDD735" }}>Setup</span>
                                </Typography>
                                <Typography color="#828584" sx={{ mb: 2, fontSize: "0.8rem" }}>
                                    Help us verify your pharmacy and activate your vendor dashboard.
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item sm={6}>
                                        <WSTextField
                                            label="Your Name *"
                                            id="name"
                                            name="name"
                                            control={control}

                                        />
                                    </Grid>
                                    <Grid item sm={6}>
                                        <WSPhone
                                            label="Mobile Number *"
                                            rules={{ required: true }}
                                            control={control}
                                            id="phoneNumber"
                                            name="phoneNumber"  // Keep only this
                                        />

                                    </Grid>
                                    <Grid item sm={6}>
                                        <WSTextField
                                            control={control}
                                            id="email"
                                            {...register("email")}
                                            name="email"
                                            rules={customValidation(true, validations.email)}
                                            label="Email *"

                                        ></WSTextField>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <WSSelectField
                                            rules={{ required: false }}

                                            id="vendorTypeId"
                                            control={control}
                                            source={vendorTypeSouse}
                                            transFormData={transFormDataVendorType}
                                            label="Vendor Type"
                                            name="vendorTypeId"
                                        // multiple={true}
                                        />
                                    </Grid>
                                    {/* <Grid item sm={12} xs={12}>
                                     Address

                                    </Grid> */}
                                    <Grid item sm={6} xs={12}>
                                        <WSTextField control={control} id="addressLine1" name="addressLine1" rules={{ required: true }} label="Address Line1 *"></WSTextField>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <WSTextField control={control} id="addressLine2" name="addressLine2" rules={{ required: false }} label="Address Line2 "></WSTextField>
                                    </Grid>
                                    <Grid item sm={4} xs={12}>
                                        <WSTextField control={control} id="state" name="state" rules={{ required: true }} label="State *"></WSTextField>
                                    </Grid>
                                    <Grid item sm={4} xs={12}>
                                        <WSTextField control={control} id="city" name="city" rules={{ required: true }} label="City *"></WSTextField>
                                    </Grid>
                                    <Grid item sm={4} xs={12}>
                                        <WSTextField control={control} id="pincode" name="pincode" rules={{ required: true }} label="Pincode *" maxLength={6}></WSTextField>
                                    </Grid>

                                    <Grid item sm={6} xs={12}>
                                        <WSTextField control={control} id="companyName" name="companyName" rules={{ required: true }} label="Company Name *"></WSTextField>

                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <WSTextField
                                            control={control}
                                            id="licenceNumber"
                                            name="licenceNumber"
                                            rules={{ required: true }}  // Add this
                                            label="Licence Number *"
                                        />

                                    </Grid>

                                    <Grid item sm={6} xs={12}>
                                        <WSTextField control={control} id="GSTNumber" name="GSTNumber" rules={{ required: true }} label="GST Number "></WSTextField>

                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <WSTextField control={control} id="panNumber" name="panNumber" rules={{ required: true }} label="Pan Number "></WSTextField>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "#098963",
                                                color: "white",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                mt: 0,
                                                "&:hover": {
                                                    backgroundColor: "#379e80", // Change to any color you like
                                                },
                                            }}
                                            disabled={loading}
                                        >
                                            Complete
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Grid>
                </Grid>

                <ThankYouDialog open={open} onClose={handleOnClose} />
            </Grid>
        </>
    );
});